import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Grid, Header } from 'semantic-ui-react'
import {
  CUSTOMIZING_LOADER,
  FEEDBACK_VIEWS_LOADER,
  DASHBOARD_LOADER,
  CHECKLIST_LOADER,
  SUCCESS_LOADER,
} from './constants'
import './style.css'

const TRANSITION_TIME = 1500
const STOP_ANIMATION = -1

export default function OnboardingLoading({ apiLoading, queue, onComplete }) {
  const [currentStep, setCurrentStep] = useState(0)
  const [key, setKey] = useState(0)

  const loaderPage = useMemo(() => {
    if (!queue) {
      return [CUSTOMIZING_LOADER]
    }
    const steps = [
      { condition: true, loader: CUSTOMIZING_LOADER },
      {
        condition: queue?.includes('Creating custom feedback views...'),
        loader: FEEDBACK_VIEWS_LOADER,
      },
      { condition: queue?.includes('Creating custom reports views...'), loader: DASHBOARD_LOADER },
      { condition: queue?.includes('Creating checklist items...'), loader: CHECKLIST_LOADER },
    ]

    return steps.filter((step) => step.condition).map((step) => step.loader)
  }, [queue])

  const [isCompleted, setIsCompleted] = useState(false)
  const [emoji, text] = loaderPage[currentStep]
  const [successEmoji, successText] = SUCCESS_LOADER

  const apiLoadingRef = useRef(apiLoading)
  const loaderPageRef = useRef(loaderPage)
  const onCompleteRef = useRef(onComplete)
  const currentStepRef = useRef(0)

  useEffect(() => {
    apiLoadingRef.current = apiLoading
  }, [apiLoading])

  useEffect(() => {
    loaderPageRef.current = loaderPage
  }, [loaderPage])

  useEffect(() => {
    onCompleteRef.current = onComplete
  }, [onComplete])

  useEffect(() => {
    // Using useRef to maintain the latest values of apiLoading and loaderPage
    // without disrupting the animation loop when they change

    const completeTimers = []

    const runStep = () => {
      if (apiLoadingRef.current) {
        return
      }
      const isLastPage = currentStepRef.current >= loaderPageRef.current.length - 1

      if (isLastPage) {
        setKey(STOP_ANIMATION)
        setIsCompleted(true)
        completeTimers.push(
          setTimeout(() => {
            onCompleteRef.current()
          }, TRANSITION_TIME)
        )
        return
      }
      currentStepRef.current += 1
      setCurrentStep(currentStepRef.current)
    }

    const stepInterval = setInterval(runStep, TRANSITION_TIME)

    return () => {
      clearInterval(stepInterval)
      completeTimers.forEach(clearTimeout)
    }
  }, [])

  const displayEmoji = isCompleted ? successEmoji : emoji
  const displayText = isCompleted ? successText : text

  return (
    <Grid
      id="loader"
      columns={1}
      key={`loader-${key}-${currentStep}`}
      textAlign="center"
      verticalAlign="middle"
      style={{ height: '100vh', margin: 0, backgroundColor: 'white' }}
    >
      <Grid.Column
        style={{ display: 'flex', flexDirection: 'column' }}
        verticalAlign="middle"
        textAlign="center"
      >
        <span className="text-6xl emoji" role="img" aria-label="emoji">
          {displayEmoji}
        </span>
        <Header as="h1" className="text">
          {displayText}
        </Header>
      </Grid.Column>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/OnboardingLoading/index.js